import { numerWypowiedzi } from "@shared/numeracja.js";
import { policzPowtarzaneSlowa, type PowtarzaneSlowo, type PozycjaListySlow } from "@shared/powtarzaneSlowa.js";
import type { RecenzjaWypowiedz } from "@shared/recenzjeTypy.js";
import dane from "../../../methodology/powtarzane-slowa.json";
import type { UtteranceDto } from "./api.js";

/**
 * Funkcja "Powtarzane slowa" po stronie przegladarki: lista slow i liczenie na wypowiedziach, ktore strona juz ma.
 *
 * LISTA PRZYCHODZI PRZY BUDOWANIU, NIE Z API. Vite importuje methodology/powtarzane-slowa.json do kodu strony (TypeScript
 * zna jego ksztalt dzieki resolveJsonModule), wiec ani karta oceny, ani link recenzenta nie robia zadnego dodatkowego
 * zapytania. Ten sam plik serwer waliduje przy starcie (src/methodology/powtarzaneSlowaSchema.ts), a test
 * tests/unit/powtarzaneSlowaPlik.test.ts pilnuje go w CI, wiec tutaj typ sprawdza tylko pola, ktorych uzywamy.
 *
 * Skutek: zmiana listy dochodzi do przegladarki dopiero z nowym buildem (jak cala metodyka: commit i wdrozenie), a
 * przycisk "Przeladuj metodyke" zmienia tylko kopie serwera. Plik jest publiczny razem z notatkami (link recenzenta
 * dziala bez logowania), dlatego nie ma w nim niczego poufnego.
 */

export const LISTA_POWTARZANYCH_SLOW: readonly PozycjaListySlow[] = dane.slowa;

/** Powtarzane slowa po kluczu mowcy. Brak wpisu znaczy: u tego mowcy nic sie nie powtarza. */
export type PowtarzaneSlowaWgMowcy = ReadonlyMap<string, readonly PowtarzaneSlowo[]>;

/** Analiza (karta oceny administratora): kluczem mowcy jest Speaker.id, czyli MowcaRaportu.klucz. */
export function powtarzaneSlowaSesji(
  wypowiedzi: readonly Pick<UtteranceDto, "index" | "speakerId" | "text">[],
): PowtarzaneSlowaWgMowcy {
  return policzPowtarzaneSlowa(
    wypowiedzi.map((u) => ({ mowca: u.speakerId, numer: numerWypowiedzi(u.index), tekst: u.text })),
    LISTA_POWTARZANYCH_SLOW,
  );
}

/** Klucz mowcy w linku recenzenta: indeks w RecenzjaRozmowa.mowcy jako tekst. */
export function kluczMowcyRecenzji(indeks: number): string {
  return String(indeks);
}

/** Link recenzenta: te same dane, ktore recenzent juz dostal (numer, indeks mowcy, tekst). Zadne nowe pole nie wychodzi. */
export function powtarzaneSlowaRecenzji(
  wypowiedzi: readonly Pick<RecenzjaWypowiedz, "numer" | "mowca" | "tekst">[],
): PowtarzaneSlowaWgMowcy {
  return policzPowtarzaneSlowa(
    wypowiedzi.map((w) => ({ mowca: kluczMowcyRecenzji(w.mowca), numer: w.numer, tekst: w.tekst })),
    LISTA_POWTARZANYCH_SLOW,
  );
}
